import Action from 'constants/action-types'
import {
  SET_USER_TOKEN,
  SET_USERNAME,
  SET_FETCHING_LOGIN,
  SET_LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  LOGOUT,
} from 'constants/action-types'
import { AuthState } from 'types/auth'

const initialState: AuthState = {
  token: null,
  username: null,
  isLoggingIn: false,
  loginError: null,
}

export default (state: AuthState = initialState, action: Action): AuthState => {
  switch (action.type) {
    case SET_USER_TOKEN:
      return {
        ...state,
        token: action.payload,
      }

    case SET_USERNAME:
      return {
        ...state,
        username: action.payload,
      }

    case SET_FETCHING_LOGIN:
      return {
        ...state,
        isLoggingIn: action.payload,
      }

    case SET_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload,
      }

    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        loginError: null,
      }

    case LOGOUT:
      return initialState

    default:
      return state
  }
}
